export const showCmsSuccessAlert = () => {
  alert("Data saved successfully");
};

export const showCmsErrorAlert = (error) => {
  alert(error?.response?.data?.message || "Something went wrong");
};
